import { render, staticRenderFns } from "./ReconcilationHeader.vue?vue&type=template&id=56c27c7c&"
import script from "./ReconcilationHeader.vue?vue&type=script&lang=js&"
export * from "./ReconcilationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports